import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { useDashboardRepresentante } from './hooks/useDashboard.js';
import { KpiCard } from './components/KpiCard.js';
import { GaugeChart } from './components/GaugeChart.js';
import { AlertCard } from './components/AlertCard.js';
import { DashboardErrorBoundary } from './components/DashboardErrorBoundary.js';
import type { KpiMetric } from '@azoupvendas/shared';

// AIDEV-NOTE: Dashboard do representante — visitas hoje, rota, km percorrido
export function DashboardRepresentante() {
  const { data, isLoading, error } = useDashboardRepresentante();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        Erro ao carregar dashboard do representante.
      </Typography>
    );
  }

  const kpis: KpiMetric[] = [
    { label: 'Visitas Hoje', value: data.visitasHoje, unit: 'number' },
    { label: 'Concluidas', value: data.visitasConcluidas, unit: 'number' },
    { label: 'Km Percorrido', value: data.kmPercorrido, unit: 'number' }
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        {/* Gauge meta */}
        <Grid item xs={12} sm={4}>
          <DashboardErrorBoundary>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Meta Mensal
                </Typography>
                <GaugeChart goalPercent={data.metaPercent} />
              </CardContent>
            </Card>
          </DashboardErrorBoundary>
        </Grid>

        {/* KPI Cards */}
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2}>
            {kpis.map((kpi) => (
              <Grid item xs={4} key={kpi.label}>
                <DashboardErrorBoundary>
                  <KpiCard metric={kpi} />
                </DashboardErrorBoundary>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Alertas */}
        <Grid item xs={12}>
          <DashboardErrorBoundary fallbackMessage="Erro ao renderizar alertas">
            <Card>
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  Alertas
                </Typography>
                <AlertCard alertas={data.alertas} />
              </CardContent>
            </Card>
          </DashboardErrorBoundary>
        </Grid>
      </Grid>
    </Box>
  );
}
